
import { defineComponent, Suspense, onUnmounted } from 'vue'
import {
  createQuestionCreator,
  QuestionTypes,
} from '@/factories/questionCreator/createQuestionCreator'

import Challenge from '@/pages/Challenges/components/Challenge.vue'

const newTestamentQuestionCreator = createQuestionCreator(
  QuestionTypes.GuessTheVerse,
  QuestionTypes.GuessTheReference
)

export default defineComponent({
  components: { Challenge },
  setup() {
    onUnmounted(() => clearInterval(window.clock)) // TODO think of a workaround

    return {
      Suspense,
      newTestamentQuestionCreator,
    }
  },
})
